import { USER_LEFT_PROPERTY_VIEW, UserLeftPropertyViewAction } from './propertyViewActions';

export const userLeftPropertyView = (): UserLeftPropertyViewAction => ({
  type: USER_LEFT_PROPERTY_VIEW,
});

